export default "/dist/files/icone_flore.ac4efcff837cd37cf0a67619840bfd81.svg";